import { Component, OnInit, Input } from '@angular/core';
import { HttpService } from '../../services/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenService } from '../../services/authen.service';
import { Principal } from "../../models/Principal/principal.model";
@Component({
    selector: 'principal-detail',
    templateUrl: 'principal-detail.html',
})
export class PrincipalDetailComponent implements OnInit {
    subs: any = null;
    id: number = 0;
    principal = new Principal();
  
   

    constructor(private auth: AuthenService, private route: ActivatedRoute, private router: Router,
        private http: HttpService) {
        this.subs = route.params.subscribe(params => {
            this.id = params['id'];
            if (this.id) {
                this.getPrincipalByID(this.id);
            }
          

        });
    }

    ngOnInit() {

    }
    getPrincipalByID(id) {
        this.http.get('api/Principal/GetPrincipalByID/' + id, res => {
            this.principal = res.Result;
        }, null);
    }
    savePrincipal() {
        var dataSave = this.principal;
        this.http.save('api/Principal/SavePrincipal', dataSave, res => {
            this.principal.ID = res.ID;
            this.router.navigate(['/principal-detail', res.ID]);
        }, null);
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }
}
